// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"0a415660","550":"4c87d9af"}[chunkId] + ".chunk.js";
};